export var item = Symbol('item');
export default {
  item: item
};